import {
  ServiceDocumentStage,
  ServiceDocumentMode,
  ServiceDocumentParamsServer
} from 'shared/entities/documents';
import { TariffKind } from 'shared/entities/tariff';

export class ServiceDocumentCommonParamsTableModel {
  readonly stage: ServiceDocumentStage;
  readonly mode: ServiceDocumentMode;
  readonly sum: number;
  readonly days: number | null;
  readonly bonus: number | null;
  readonly bonusForPromoCode: number | null;
  readonly bonusForMonths: number | null;
  readonly months: number | null;
  readonly promoCode: string | null;
  readonly cabinetTariff: TariffKind | null;
  readonly cabinetTariffMonthPrice: number | null;

  constructor({
    sum,
    days,
    stage,
    mode,
    bonus,
    bonusForPromoCode,
    bonusForMonths,
    months,
    promoCode,
    cabinetTariff,
    cabinetTariffMonthPrice
  }: {
    stage: ServiceDocumentStage;
    sum: number;
    days: number | null;
    mode: ServiceDocumentMode;
    bonus: number | null;
    bonusForPromoCode: number | null;
    bonusForMonths: number | null;
    months: number | null;
    promoCode: string | null;
    cabinetTariff: TariffKind | null;
    cabinetTariffMonthPrice: number | null;
  }) {
    this.sum = sum;
    this.days = days;
    this.stage = stage;
    this.mode = mode;
    this.bonus = bonus;
    this.bonusForPromoCode = bonusForPromoCode;
    this.bonusForMonths = bonusForMonths;
    this.months = months;
    this.promoCode = promoCode;
    this.cabinetTariff = cabinetTariff;
    this.cabinetTariffMonthPrice = cabinetTariffMonthPrice;
  }

  static fromJson(
    raw: ServiceDocumentParamsServer
  ): ServiceDocumentCommonParamsTableModel {
    return new ServiceDocumentCommonParamsTableModel({
      stage: raw.stage,
      sum: raw.sum,
      bonus: raw.bonus ?? null,
      days: raw.days === undefined ? null : raw.days,
      mode: raw.mode,
      bonusForPromoCode: raw.bonus_for_promocode ?? null,
      bonusForMonths: raw.bonus_for_months ?? null,
      months: raw.months ?? null,
      promoCode: raw.promocode ?? null,
      cabinetTariff: raw.cabinet_tariff ?? null,
      cabinetTariffMonthPrice: raw.cabinet_tariff_month_price ?? null
    });
  }
}
